var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "hero is-primary hero-header",
      class: `has-hero-text-${_vm.$theme.name}`,
    },
    [
      _c("div", { staticClass: "hero-body paddingless" }, [
        _c(
          "nav",
          { staticClass: "navbar", attrs: { id: "app-detail-header" } },
          [
            _c("div", { staticClass: "navbar-brand" }, [
              _c("div", { staticClass: "navbar-item is-hidden-desktop" }, [
                _c("div", { staticClass: "field is-grouped" }, [
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "button tooltip is-tooltip is-tooltip-topleft is-primary",
                        class: _vm.buttonCSS,
                        attrs: {
                          id: "toggle",
                          title: "Toggle Side Menu",
                          "data-tooltip": "Toggle Side Menu",
                        },
                        on: { click: _vm.toggleSide },
                      },
                      [_vm._m(0)]
                    ),
                  ]),
                  !_vm.serviceError && _vm.showExport
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "button tooltip is-tooltip-topleft is-success",
                            class: _vm.buttonCSS,
                            attrs: {
                              id: "export",
                              title: "Export",
                              "data-tooltip": "Export",
                            },
                            on: { click: _vm.exportreport },
                          },
                          [_vm._m(1)]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.serviceError && _vm.showEmail
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "button tooltip is-tooltip-topleft is-primary",
                            class: _vm.buttonCSS,
                            attrs: {
                              id: "email",
                              title: "Email",
                              "data-tooltip": "Email",
                            },
                            on: { click: _vm.email },
                          },
                          [_vm._m(2)]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.serviceError && _vm.showPrint
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button tooltip is-tooltip-topleft",
                            class: _vm.buttonCSS,
                            attrs: {
                              id: "print",
                              title: "Print",
                              "data-tooltip": "Print",
                            },
                            on: { click: _vm.print },
                          },
                          [_vm._m(3)]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._m(4),
            ]),
            _c(
              "div",
              {
                staticClass: "navbar-start is-hidden-touch",
                attrs: { id: "detail-nav-menu" },
              },
              [
                _c("div", { staticClass: "navbar-item" }, [
                  _c(
                    "h1",
                    { staticClass: "title has-text-weight-semibold" },
                    [
                      _vm.showToggle
                        ? _c(
                            "a",
                            {
                              staticClass: "button is-primary is-outlined",
                              class: _vm.buttonCSS,
                              on: { click: _vm.toggleSide },
                            },
                            [_vm._m(5)]
                          )
                        : _vm._e(),
                      _vm._l(_vm.$route.matched.slice(), function (route, idx) {
                        return _c("span", { key: idx }, [
                          idx > 0 ? _c("span", [_vm._m(6, true)]) : _vm._e(),
                          _c("span", [
                            _vm._v(" " + _vm._s(route.meta.title) + " "),
                          ]),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "navbar-end is-hidden-touch" }, [
              _c("div", { staticClass: "navbar-item" }, [
                _c("div", { staticClass: "field is-grouped" }, [
                  !_vm.serviceError && _vm.showExport
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button is-success",
                            class: _vm.buttonCSS,
                            attrs: { id: "export" },
                            on: { click: _vm.exportreport },
                          },
                          [_vm._m(7), _c("span", [_vm._v("Export")])]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.serviceError && _vm.showEmail
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button is-primary",
                            class: _vm.buttonCSS,
                            attrs: { id: "email" },
                            on: { click: _vm.email },
                          },
                          [_vm._m(8), _c("span", [_vm._v("Email")])]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.serviceError && _vm.showPrint
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button",
                            class: _vm.buttonCSS,
                            attrs: { id: "print" },
                            on: { click: _vm.print },
                          },
                          [_vm._m(9), _c("span", [_vm._v("Print")])]
                        ),
                      ])
                    : _vm._e(),
                  _vm.showBack
                    ? _c("p", { staticClass: "control" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button is-primary",
                            class: _vm.buttonCSS,
                            attrs: { id: "back" },
                            on: { click: _vm.back },
                          },
                          [_vm._m(10), _c("span", [_vm._v("Back")])]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-menu" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-export" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-email" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-printer" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "navbar-burger burger",
        attrs: { "data-target": "action-button-menu" },
      },
      [_c("span"), _c("span"), _c("span")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-menu mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-chevron-right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-export mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-email mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-printer mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-arrow-left-bold mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }